export default "__VITE_ASSET__DuZdg$XE__"